import fp from 'lodash/fp'
import { combine, withCallback } from 'react-hooks-combine'
import { withFormModel, withMobxAutorun } from 'shared/hooks'
import { spec, validators } from 'utils/validation'

import EventsFiltersComponent from './component'

export const EventsFilters = combine(
  withFormModel(
    {
      search: {
        initialValue: '',
        spec: spec.flow(validators.any.required),
      },
      inWinnable: {
        initialValue: false,
        spec: spec.flow(validators.any.required),
      },
    },
    { id: 'events-filters-form' }
  ),

  withCallback(
    'onSearchRequest',
    (_state, { debounce, onSearch }) => {
      return fp.isNumber(debounce) ? fp.debounce(debounce, onSearch) : onSearch
    },
    ['debounce', 'onSearch']
  ),

  withMobxAutorun(
    ({ firstRun, state: { form, onSearchRequest } }) => {
      const search = form.getControl('search')
      const inWinnable = form.getControl('inWinnable')
      const query = { search: search.value, inWinnable: inWinnable.value }

      if (firstRun) {
        return
      }

      onSearchRequest(query)
    },
    ['onSearchRequest']
  )
)(EventsFiltersComponent)
